import React from 'react';
import {
    DataGrid,
    DataGridToolbar,
    DataGridToolbarButtonsGroup,
    DataGridToolbarCheckBox,
    DataGridToolbarErrorsButton,
    DataGridToolbarButtonSave,
    DataGridToolbarButtonDiscard,
    DataGridToolbarButtonRefresh,
    //DataGridToolbarButtonImport,
    DataGridToolbarButtonExport,
    DataGridToolbarButtonDelete,
    DataGridToolbarFavoritesSplitButton
} from '../BaseComponents';

import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';

const Toolbar = () => {
    return (
        <DataGridToolbar
            title="Lookup Values"
        >
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarErrorsButton />
                <DataGridToolbarButtonSave />
                <DataGridToolbarButtonDiscard />
            </DataGridToolbarButtonsGroup>{' '}
            <DataGridToolbarCheckBox
                id="showDeletedCheckBox"
                filterOrder="1"
                filterWhenChecked="all"
                filterWhenUnchecked="enabled"
                caption="Show Deleted"
            />
            <DataGridToolbarButtonsGroup>
                <DataGridToolbarButtonRefresh />
                <DataGridToolbarButtonExport />
                <DataGridToolbarButtonDelete />
                <DataGridToolbarFavoritesSplitButton />
            </DataGridToolbarButtonsGroup>
        </DataGridToolbar>
    );
};

const LookupValues = () => {
    return (
        <DataGrid model='lookupvalue'>
            <Toolbar />
        </DataGrid>
    );
};

export default withAITracking(ai.reactPlugin, LookupValues, "LookupValues");